import React, { useState, useEffect, useMemo } from "react";
import HeartRate from "../../assets/icons/heart-rate-2.svg";
import Temp from "../../assets/icons/temp.svg";
import BloodPressure from "../../assets/icons/blood-pressure.svg";
import BloodAnalysis from "../../assets/icons/body-analysis.svg";
import Weight from "../../assets/icons/weight.svg";
import DefaultBodyCompositionImage from "../../assets/default-body-composition-image.png";
import HeightIcon from "../../assets/icons/height.svg";
import { setTestsData } from "../../Redux_Services/slices/testSlice";
import axios from "axios";
import { useSelector, useDispatch } from "react-redux";
import { toast } from "react-toastify";
import API_ENDPOINTS from "../../service/api";
import "react-toastify/dist/ReactToastify.css";
import { useGeneralTestLogic } from "../../Hooks/DependentTest";

export default function BodyComposition() {
  const dispatch = useDispatch();

  // 🔸 flat parameters list (no subFields)
  const tests = {
    name: "Body Analysis",
    fields: [
      {
        inputType: "Text",
        inputFieldType: "Input",
        subCategory: [],
        _id: "686dde6290d7e6a6c8eba63f",
        name: "Weight",
        unit: "Kg",
        ParameterID: "BO0608",
        autoFetchKey: "N/A",
        referenceRange: "N/A",
      },
      {
        inputType: "Text",
        inputFieldType: "Input",
        subCategory: [],
        _id: "686dde6290d7e6a6c8eba63d",
        name: "Heart Rate",
        unit: "bpm",
        ParameterID: "BO2540",
        autoFetchKey: "N/A",
        referenceRange: "N/A",
      },
      {
        inputType: "Text",
        inputFieldType: "Input",
        subCategory: [],
        _id: "686dde6290d7e6a6c8eba63b",
        name: "Systolic",
        unit: "mm of Hg",
        ParameterID: "BO3857",
        autoFetchKey: "N/A",
        referenceRange: "90–120",
      },
      {
        inputType: "Text",
        inputFieldType: "Input",
        subCategory: [],
        _id: "686dde6290d7e6a6c8eba63c",
        name: "Diastolic",
        unit: "mm of Hg",
        ParameterID: "BO4978",
        autoFetchKey: "N/A",
        referenceRange: "60–80",
      },
      {
        inputType: "Text",
        inputFieldType: "Input",
        subCategory: [],
        _id: "686dde6290d7e6a6c8eba63e",
        name: "Height",
        unit: "cm",
        ParameterID: "BO5644",
        autoFetchKey: "N/A",
        referenceRange: "N/A",
      },
      {
        inputType: "Text",
        inputFieldType: "Input",
        subCategory: [],
        _id: "686dde6290d7e6a6c8eba645",
        name: "Resting Metabolism",
        unit: "Kcal",
        ParameterID: "BO5977",
        autoFetchKey: "N/A",
        referenceRange: "N/A",
      },
      {
        inputType: "Text",
        inputFieldType: "Input",
        subCategory: [],
        _id: "686dde6290d7e6a6c8eba640",
        name: "BMI",
        unit: "Kg/ m2",
        ParameterID: "BO6353",
        autoFetchKey: "N/A",
        referenceRange: "18.5-24.9",
      },
      {
        inputType: "Text",
        inputFieldType: "Input",
        subCategory: [],
        _id: "686dde6290d7e6a6c8eba644",
        name: "Body Age",
        unit: "-",
        ParameterID: "BO6603",
        autoFetchKey: "N/A",
        referenceRange: "N/A",
      },
      {
        inputType: "Text",
        inputFieldType: "Input",
        subCategory: [],
        _id: "686dde6290d7e6a6c8eba641",
        name: "Body Fat",
        unit: "%",
        ParameterID: "BO6682",
        autoFetchKey: "N/A",
        referenceRange: "N/A",
      },
      {
        inputType: "Text",
        inputFieldType: "Input",
        subCategory: [],
        _id: "686dde6290d7e6a6c8eba643",
        name: "Skeletal Muscle",
        unit: "%",
        ParameterID: "BO6881",
        autoFetchKey: "N/A",
        referenceRange: "N/A",
      },
      {
        inputType: "Text",
        inputFieldType: "Input",
        subCategory: [],
        _id: "686dde6290d7e6a6c8eba63a",
        name: "Spo2",
        unit: "-",
        ParameterID: "BO7972",
        autoFetchKey: "N/A",
        referenceRange: ">95%",
      },
      {
        inputType: "Text",
        inputFieldType: "Input",
        subCategory: [],
        _id: "686dde6290d7e6a6c8eba646",
        name: "Temperature",
        unit: "F",
        ParameterID: "BO8158",
        autoFetchKey: "N/A",
        referenceRange: "97-99",
      },
      {
        inputType: "Text",
        inputFieldType: "Input",
        subCategory: [],
        _id: "686dde6290d7e6a6c8eba642",
        name: "Visceral Fat",
        unit: "%",
        ParameterID: "BO8701",
        autoFetchKey: "N/A",
        referenceRange: "N/A",
      },
    ],
  };

  const referedByRedux = useSelector((state) => state.testSlice.referedBy || "");
  const patientDetails = useSelector((state) => state.patientSlice.patientData);
  const UserData = useSelector((state) => state.authSlice.user);

  const [testData, setTestData] = useState(tests);

  // 🔹 ensure result is always a STRING here as well
  const bodyAnalysisTestsForHook = useMemo(() => {
    if (!testData?.fields) return [];
    const options = testData.fields.map((field) => ({
      ...field,
      result:
        field.value === undefined || field.value === null
          ? ""
          : String(field.value),
    }));
    return [{ name: testData.name, options }];
  }, [testData]);

  const { referredBy, setReferredBy, saveResults, saveReferredBy } =
    useGeneralTestLogic(bodyAnalysisTestsForHook, referedByRedux);

  const [, setUpdate] = useState(false);
  const [temperatureTest, setTemperatureTest] = useState(false);
  const [bloodPressureTest, setBloodPressureTest] = useState(false);
  const [heartRateTest, setHeartRateTest] = useState(false);

  const [xFactor, setXFactor] = useState(0);
  const [loading, setLoading] = useState(false);

  const [gender] = useState("Male"); // default

  const [, setForm] = useState(" ");

  const defaultImpedanceData = {
    body_oxygen_saturation: null,
    visceral_fat: null,
    body_fat: null,
    skeletal_muscle: null,
    body_age: null,
    resting_metabolism: null,
    bmi: null,
  };
  const [impedanceData, setImpedanceData] = useState(defaultImpedanceData);

  const [formData, setFormData] = useState({
    temperature: "",
    bloodPressure: "",
    systolic: "",
    diastolic: "",
    heartRate: "",
    height: "",
    weight: "",
    spo2: "",
  });

  useEffect(() => {
    getFactors();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getFactors = async () => {
    try {
      const response = await axios.get(
        `${API_ENDPOINTS.getFactor}?MachineID=${UserData.MachineID}`,
        { headers: { Authorization: `Bearer ${UserData.token}` } }
      );
      if (response.status === 200) {
        toast.success("The scale factor is applied", {
          position: "top-center",
          autoClose: 3000,
        });
        setXFactor(Number(response.data.value) || 0);
      } else {
        toast.error("The scale factor is not applicable", {
          position: "top-center",
          autoClose: 3000,
        });
        setXFactor(Number(response.data.value) || 0);
      }
    } catch (error) {
      toast.error("Error getting scale factor", {
        position: "top-center",
        autoClose: 3000,
      });
    }
  };

  const weightFactor = (value) => {
    const v = Number(value);
    if (UserData.MachineID === "MC0005") {
      return v > 80
        ? 0.95 * v * v * v - 1.5 * v * v + 0.9 * v + 3.0
        : 1.02 * v * v + 0.98 * v + 2.5;
    }
    return v;
  };

  // 🔹 do math in numbers, store STRINGS in state
  const calculateMetrics = () => {
    // console.log("calculateMetrices");
    const h = Number(formData.height);
    const w = Number(formData.weight);
    const age = Number(patientDetails?.Age);
    // console.log(h, w, age, "---261---");

    if (!h || !w) return;

    const heightInMeter = h / 100;
    const isMale = gender === "Male";

    const rawBmi = w / (heightInMeter * heightInMeter);
    const bmi = rawBmi.toFixed(2); // string

    const rawBodyFat = isMale
      ? 1.2 * rawBmi + 0.23 * age - 16.2
      : 1.2 * rawBmi + 0.23 * age - 5.4;
    const bodyFat = rawBodyFat.toFixed(2); // string

    const rawBodyAge = age + (rawBmi - 22);
    const bodyAge = rawBodyAge.toFixed(2); // string

    const rawResting = isMale
      ? 10 * w + 6.25 * h - 5 * age + 5
      : 10 * w + 6.25 * h - 5 * age - 161;
    const resting = rawResting.toFixed(2); // string

    const rawSkeletal = (isMale ? 0.4 : 0.37) * w;
    const skeletal = rawSkeletal.toFixed(2); // string

    const rawVisceralFat = 0.1 * rawBmi + 0.23 * age - 5.4;
    const visceralFat = rawVisceralFat.toFixed(2); // string

    // console.log(visceralFat, resting, skeletal, bodyFat, bmi, "283");

    // ✅ all STRINGS in impedanceData
    setImpedanceData({
      body_oxygen_saturation: "",
      visceral_fat: visceralFat,
      body_fat: bodyFat,
      skeletal_muscle: skeletal,
      body_age: bodyAge,
      resting_metabolism: resting,
      bmi,
    });

    // console.log(impedanceData, "impedance Data");
  };

  useEffect(() => {
    if (formData.height && formData.weight && Number(patientDetails?.Age) > 0) {
      // console.log(impedanceData, "impedance Data");
      calculateMetrics();
    } else {
      setImpedanceData(defaultImpedanceData);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formData.height, formData.weight, gender, patientDetails?.Age]);

  const fetchDataFromServer = async (task_id) => {
    setLoading(true);

    try {
      const { data } = await axios.post("http://localhost:5500/perform_task", {
        task_id,
        name: patientDetails.Name,
        age: patientDetails.Age,
        user_id: patientDetails.PatientID,
        gender: "Male",
      });

      if (data?.success) {
        if (task_id === "measure_height") {
          setFormData((prev) => ({
            ...prev,
            height:
              Number.isFinite(xFactor) && xFactor !== 0
                ? String(Number(xFactor) - Number(data.message))
                : String(Number(data.message)),
          }));
        } else if (task_id === "measure_weight") {
          setFormData((prev) => ({
            ...prev,
            weight: String(weightFactor(Number(data.message))),
          }));
        }
        toast.success("Operation successful!", {
          position: "top-center",
          autoClose: 3000,
        });
      } else {
        toast.error(`Operation failed! ${data?.message ?? ""}`, {
          position: "top-center",
          autoClose: 3000,
        });
      }
    } catch (error) {
      toast.error(`Error fetching data from server: ${error.message}`, {
        position: "top-center",
        autoClose: 3000,
      });
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  function handleReset() {
    setImpedanceData(defaultImpedanceData);
  }

  useEffect(() => {
    if (formData.bloodPressure) {
      const [systolic, diastolic] = formData.bloodPressure.split("-");
      setFormData((prev) => ({
        ...prev,
        systolic: systolic || "",
        diastolic: diastolic || "",
      }));
    }
  }, [formData.bloodPressure]);

  // 🔹 helper to force string (for mapping into testData)
  const ensureString = (val) => {
    if (val === null || val === undefined) return "";
    return String(val);
  };

  // 🔸 map values directly into fields[i].value by field.name, as STRINGS
  useEffect(() => {
    setTestData((prev) => {
      if (!prev || !Array.isArray(prev.fields)) return prev;

      const nameToValue = (name) => {
        switch (name) {
          case "Temperature":
            return ensureString(formData.temperature);
          case "Systolic":
            return ensureString(formData.systolic);
          case "Diastolic":
            return ensureString(formData.diastolic);
          case "Heart Rate":
            return ensureString(formData.heartRate);
          case "Height":
            return ensureString(formData.height);
          case "Spo2":
            return ensureString(formData.spo2);
          case "Weight":
            return ensureString(formData.weight);

          // impedanceData now stores strings
          case "BMI":
            return ensureString(impedanceData.bmi);
          case "Body Fat":
            return ensureString(impedanceData.body_fat);
          case "Visceral Fat":
            return ensureString(impedanceData.visceral_fat);
          case "Skeletal Muscle":
            return ensureString(impedanceData.skeletal_muscle);
          case "Body Age":
            return ensureString(impedanceData.body_age);
          case "Resting Metabolism":
            return ensureString(impedanceData.resting_metabolism);
          default:
            return undefined;
        }
      };

      return {
        ...prev,
        fields: prev.fields.map((f) => {
          const v = nameToValue(f.name);
          return v !== undefined ? { ...f, value: v } : { ...f };
        }),
      };
    });
  }, [
    formData.temperature,
    formData.height,
    formData.weight,
    formData.bloodPressure,
    formData.systolic,
    formData.diastolic,
    formData.heartRate,
    formData.spo2,
    impedanceData,
  ]);

  function handleUpdate() {
    setUpdate(true);
    setTemperatureTest(true);
  }
  function handleHeart() {
    setUpdate(true);
    setHeartRateTest(true);
  }

  function handleBloodPressure() {
    setUpdate(true);
    setBloodPressureTest(true);
  }
  const spo2 = () => {
    setForm("handleT");
  };
  function handleHeight() {
    setForm("measure_height");
    fetchDataFromServer("measure_height");
  }
  function handleWeight() {
    setForm("measure_weight");
    fetchDataFromServer("measure_weight");
  }
  function handleBodyAnalysis() {
    // console.log("handleBodyAnalysis");
    calculateMetrics();
  }

  const handleSave = () => {
    if (!referredBy) {
      toast.error("referredBy is required", {
        position: "top-center",
        autoClose: 3000,
      });
      return;
    }
    const payload = [
      {
        ...testData,
        options: bodyAnalysisTestsForHook[0]?.options || [],
      },
    ];
    dispatch(setTestsData(payload));
    saveReferredBy();
    saveResults();
  };

  return (
    <div className="mt-[07%] font-popins">
      <div className="w-full max-w-[80rem] mx-auto">
        <h1 className="text-3xl mt-[-3%] px-10 font-extrabold text-[#845BB3]">
          BODY COMPOSITION
        </h1>

        <div className="flex mb-[6%] items-start w-full justify-end space-x-[10%] ">
          <div className="p-4 m-10 w-full max-w-fit flex relative ">
            <div className="flex flex-col gap-8 justify-center cursor-pointer absolute right-[60%] mr-4">
              <div
                onClick={heartRateTest ? null : handleHeart}
                className="flex flex-col items-center"
              >
                <img className="w-14 h-14" src={HeartRate} alt="Heart Rate" />
                <input
                  type="text"
                  name="heartRate"
                  placeholder="Heart Rate"
                  value={`${formData.heartRate}${
                    formData.heartRate ? " bpm" : ""
                  }`}
                  onChange={(e) => {
                    const value = e.target.value.replace(/[^0-9]/g, "");
                    setFormData({ ...formData, heartRate: value });
                    const el = e.target;
                    setTimeout(
                      () =>
                        (el.selectionStart = el.selectionEnd = value.length),
                      0
                    );
                  }}
                  className="text-[#845BB3] text-sm px-2 py-1 rounded-md border border-[#845BB3] bg-[#D7D4F8] w-28 mt-2 text-center"
                />
              </div>

              <div
                onClick={temperatureTest ? null : handleUpdate}
                className="flex flex-col items-center mr-19 "
              >
                <img className="w-14 h-14" src={Temp} alt="Temperature" />
                <input
                  type="text"
                  name="temperature"
                  placeholder="Temperature"
                  value={`${formData.temperature}${
                    formData.temperature ? " °F" : ""
                  }`}
                  onChange={(e) => {
                    const value = e.target.value.replace(/[^0-9.]/g, "");
                    setFormData({ ...formData, temperature: value });
                    const el = e.target;
                    setTimeout(
                      () =>
                        (el.selectionStart = el.selectionEnd = value.length),
                      0
                    );
                  }}
                  className="text-[#845BB3] text-sm px-2 py-1 rounded-md border border-[#845BB3] bg-[#D7D4F8] w-28 mt-2 text-center"
                />
              </div>

              <div
                onClick={bloodPressureTest ? null : handleBloodPressure}
                className="flex flex-col items-center"
              >
                <img
                  className="w-14 h-14 mb-2 mr-4"
                  src={BloodPressure}
                  alt="Blood Pressure"
                />
                <div className="flex items-center gap-2">
                  <input
                    type="text"
                    name="systolic"
                    placeholder="Systolic"
                    value={formData.systolic}
                    onChange={(e) => {
                      const value = e.target.value.replace(/[^0-9]/g, "");
                      setFormData((prev) => ({
                        ...prev,
                        systolic: value,
                        bloodPressure: `${value}-${prev.diastolic || ""}`,
                      }));
                    }}
                    className="text-[#845BB3] text-sm px-2 py-1 rounded-md border border-[#845BB3] bg-[#D7D4F8] w-16 text-center"
                  />
                  <span className="text-[#845BB3] font-semibold">/</span>
                  <input
                    type="text"
                    name="diastolic"
                    placeholder="Diastolic"
                    value={formData.diastolic}
                    onChange={(e) => {
                      const value = e.target.value.replace(/[^0-9]/g, "");
                      setFormData((prev) => ({
                        ...prev,
                        diastolic: value,
                        bloodPressure: `${prev.systolic || ""}-${value}`,
                      }));
                    }}
                    className="text-[#845BB3] text-sm px-2 py-1 rounded-md border border-[#845BB3] bg-[#D7D4F8] w-16 text-center"
                  />
                  <span className="text-[#845BB3] text-sm">mmHg</span>
                </div>
              </div>
            </div>

            <div className="flex flex-col items-center gap-2">
              <img
                className="w-[30rem] h-[30rem] object-contain mx-auto"
                src={DefaultBodyCompositionImage}
                alt="Current Body Composition"
              />

              <div className="flex flex-col items-center mt-6">
                <button
                  onClick={handleBodyAnalysis}
                  className="flex flex-col items-center"
                >
                  <img
                    className="w-14 h-14 "
                    src={BloodAnalysis}
                    alt="Body Analysis"
                  />
                </button>
                <p className="text-[#845BB3] text-sm px-2 py-1 rounded-md border border-[#845BB3] w-fit mt-2">
                  Impedance Data
                </p>

                <div className="flex flex-col items-center">
                  <button
                    onClick={handleReset}
                    className="text-red-500 text-sm px-2 py-1 rounded-md border border-red-500 w-fit mt-2"
                  >
                    Reset
                  </button>
                </div>
              </div>

              <div className="flex flex-col gap-8 justify-center absolute right-0 mr-4">
                <div className="flex flex-col items-center">
                  <button
                    onClick={handleHeight}
                    className="flex flex-col items-center"
                  >
                    <img
                      className="w-14 h-14"
                      src={HeightIcon}
                      alt="Height"
                    />
                  </button>
                  <input
                    type="text"
                    name="height"
                    placeholder="Height"
                    value={`${formData.height}${
                      formData.height ? " Cm" : ""
                    }`}
                    onChange={(e) => {
                      const value = e.target.value.replace(/[^0-9.]/g, "");
                      setFormData({ ...formData, height: value });
                      const el = e.target;
                      setTimeout(
                        () =>
                          (el.selectionStart = el.selectionEnd =
                            value.length),
                        0
                      );
                    }}
                    className="text-[#845BB3] text-sm px-2 py-1 rounded-md border border-[#845BB3] bg-[#D7D4F8] w-28 mt-2 text-center"
                  />
                </div>

                <div className="flex flex-col items-center">
                  <button
                    onClick={handleWeight}
                    className="flex flex-col items-center "
                  >
                    <img className="w-14 h-14 " src={Weight} alt="Weight" />
                  </button>
                  <input
                    type="text"
                    name="weight"
                    placeholder="Weight"
                    value={`${formData.weight}${
                      formData.weight ? " Kg" : ""
                    }`}
                    onChange={(e) => {
                      const value = e.target.value.replace(/[^0-9]/g, "");
                      setFormData({ ...formData, weight: value });
                      const el = e.target;
                      setTimeout(
                        () =>
                          (el.selectionStart = el.selectionEnd =
                            value.length),
                        0
                      );
                    }}
                    className="text-[#845BB3] text-sm px-2 py-1 rounded-md border border-[#845BB3] bg-[#D7D4F8] w-28 mt-2 text-center"
                  />
                </div>

                <div className="flex flex-col items-center">
                  <button onClick={spo2} className="flex flex-col items-center">
                    <img className="w-14 h-14" src={Weight} alt="SpO2" />
                  </button>
                  <input
                    type="text"
                    name="spo2"
                    placeholder="Spo2"
                    value={`${formData.spo2}${formData.spo2 ? " %" : ""}`}
                    onChange={(e) => {
                      const value = e.target.value.replace(/[^0-9.]/g, "");
                      setFormData({ ...formData, spo2: value });
                      const el = e.target;
                      setTimeout(
                        () =>
                          (el.selectionStart = el.selectionEnd =
                            value.length),
                        0
                      );
                    }}
                    className="text-[#845BB3] text-sm px-2 py-1 rounded-md border border-[#845BB3] bg-[#D7D4F8] w-28 mt-2 text-center"
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="flex flex-col w-full ">
            <div className="mt-10 w-full">
              <div className="text-2xl text-purple-800">
                <h2 className="font-stretch text-3xl font-bold ">
                  Impedance Data
                </h2>
              </div>
              <div className="flex flex-row gap-x-[15%] w-full">
                <div className="flex flex-col w-[50%]">
                  <div className="mt-4">
                    <h4 className="text-[#845BB3] text-lg">Skeletal Muscle</h4>
                    <p className="text-purple-800 text-sm px-2 h-9 flex items-center justify-center rounded-md border border-[#845BB3] w-[50%] mt-2">
                      {impedanceData.skeletal_muscle ?? "—"}
                    </p>
                  </div>
                  <div className="mt-4">
                    <h4 className="text-[#845BB3] text-lg">
                      Resting Metabolism
                    </h4>
                    <p className="text-purple-800 text-sm px-2 h-9 flex items-center justify-center text-bold rounded-md border border-[#845BB3] w-[50%] mt-2">
                      {impedanceData.resting_metabolism ?? "—"}
                    </p>
                  </div>
                  <div className="mt-4">
                    <h4 className="text-[#845BB3] text-lg">Body Age</h4>
                    <p className="text-purple-800 text-sm px-2 h-9 flex items-center justify-center text-bold rounded-md border border-[#845BB3] w-[50%] mt-2">
                      {impedanceData.body_age ?? "—"}
                    </p>
                  </div>
                </div>

                <div className="flex flex-col w-[50%]">
                  <div className="mt-4">
                    <h4 className="text-[#845BB3] text-lg">BMI</h4>
                    <p className="text-purple-800 text-sm px-2 h-9 flex items-center justify-center text-bold rounded-md border border-[#845BB3] w-[50%] mt-2">
                      {impedanceData.bmi ?? "—"}
                    </p>
                  </div>
                  <div className="mt-4">
                    <h4 className="text-[#845BB3] text-lg">Visceral Fat</h4>
                    <p className="text-purple-800 text-sm px-2 h-9 flex items-center justify-center text-bold rounded-md border border-[#845BB3] w-[50%] mt-2">
                      {impedanceData.visceral_fat ?? "—"}
                    </p>
                  </div>
                  <div className="mt-4">
                    <h4 className="text-[#845BB3] text-lg">Body Fat</h4>
                    <p className="text-purple-800 text-sm px-2 h-9 flex items-center justify-center text-bold rounded-md border border-[#845BB3] w-[50%] mt-2">
                      {impedanceData.body_fat ?? "—"}
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className=" flex flex-col gap-3 mt-[10%]">
              <div className="flex">
                <p className="text-2xl text-[#845BB3]">REFERRED BY:</p>
                <input
                  type="text"
                  onChange={(e) => setReferredBy(e.target.value)}
                  value={referredBy}
                  className="w-1/3 rounded-md bg-[#D7D4F8] text-center ml-2 px-3 py-2 text-base"
                />
              </div>
              <div className="flex flex-col gap-3">
                <button
                  onClick={handleSave}
                  className="bg-[#AB5C5C] w-[35%] rounded-md text-white text-base font-semibold py-2 px-2 flex items-center"
                >
                  <span className="mr-2">GENERATE REPORT</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      {loading && (
        <div className="fixed inset-0 flex items-center justify-center bg-gray-800 bg-opacity-50 z-50">
          <div className="w-10 h-10 border-4 border-t-red-500 border-gray-300 rounded-full animate-spin"></div>
        </div>
      )}
    </div>
  );
}
